import moment from "moment"
import {
    salesData,
    setSession,
    getSession
} from '../../tools/config'
let salesDataInfo = {
    state: {
        query: {},
        territory_id: '',
        month: moment().format("YYYY-MM"),
        territoryArr: [],
        territoryDatas: [],
        sku_id: '',
        store_id: '',
        tabPosition: '按产品',
        search: '',
    },
    mutations: {
        setDataKey(state, val) {
            for (let key in val) {
                state[key] = val[key]
            }
            setSession(salesData, state)
        },

    },
    getters: {
        getDataTerritoryId(state) {

            if (getSession(salesData)) {
                state.territory_id = getSession(salesData).territory_id || ''
                return state.territory_id
            } else {
                return ''
            }
        },
        getTerritoryArr(state) {
            if (getSession(salesData)) {
                state.territoryArr = getSession(salesData).territoryArr || []
                return state.territoryArr
            } else {
                return []
            }

        },
        getTerritoryMonth(state) {
            if (getSession(salesData)) {
                state.month = getSession(salesData).month || moment().format("YYYY-MM")
                return state.month
            } else {
                return moment().format("YYYY-MM")
            }

        },
        getTerritorySearch(state) {
            if (getSession(salesData)) {
                state.search = getSession(salesData).search || ''
                return state.search
            } else {
                return ''
            }

        },
        getTerritoryDatas(state) {
            if (getSession(salesData)) {
                state.territoryDatas = getSession(salesData).territoryDatas || []
                return state.territoryDatas
            } else {
                return []
            }

        },
        getSalesSkuId(state) {
            if (getSession(salesData)) {
                state.sku_id = getSession(salesData).sku_id || ''
                return state.sku_id
            } else {
                return ''
            }

        },
        getSalesStoreId(state) {
            if (getSession(salesData)) {
                state.store_id = getSession(salesData).store_id || ''
                return state.store_id
            } else {
                return ''
            }

        },

        getDataQuery(state) {
            if (getSession(salesData)) {
                state.query = getSession(salesData).query || {}
                return state.query
            } else {
                return {}
            }

        }
    }
}

export default salesDataInfo



// WEBPACK FOOTER //
// ./src/store/modules/salesData.js